import React, { Component } from 'react';
import $ from "jquery";

class WarningModal extends Component {

    Cancel = async () => {
        const { cancel } = this.props;
        cancel();
        $('#warningModal').modal('hide');
    };

    Accept = async () => {
        const { accept } = this.props;
        accept();
        $('#warningModal').modal('hide');
    };

    render() {
        const {
            title,
            message,
            btnAccept,
            btnCancel,
            size,
            btnClose = true,
        } = this.props;

        const paragraphs = message.split('\\n');

        return (
            <div className="modal fade bd-example-modal-sm modal-open scroll" id="warningModal" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="warningModalLabel" aria-hidden="true">
                <div className={"modal-dialog modal-open " + size} role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">{title}</h4>
                            {btnClose && (
                                <button type="button" className="close" onClick={this.Cancel} aria-label="Close">
                                    <span className="text-white" aria-hidden="true"> &times; </span>
                                </button>
                            )}
                        </div>

                        <div className="modal-body" >
                            <div className="w-100 tab-pane fade show active text-left" aria-labelledby="nav-home-tab-Contenido" style={{ marginBottom: 0, maxHeight: 500 }}>
                                {paragraphs.map( (paragraph) => { return ( <>{paragraph} <br /></> )})}
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn botonCorrect" onClick={this.Accept}>
                                    {btnAccept}
                            </button>
                            <button type="button" className="btn botonCerrar text-white" onClick={this.Cancel}>
                                    {btnCancel}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default WarningModal;